import { gql } from '__generated__'

export const BotAuditStats = gql(/* GraphQL */ `
    query BotAuditStats($range: BotAuditRange!) {
        botAuditStats(range: $range) {
            conversations
            messages
            verdictBreakdown {
                yes
                partial
                no
                unjudged
            }
            feedbackBreakdown {
                positive
                negative
                none
            }
            p50DurationMs
            p95DurationMs
            errorCount
        }
    }
`)

export const BotAuditNeedsAttention = gql(/* GraphQL */ `
    query BotAuditNeedsAttention {
        partialOrNo: botAuditMessages(verdicts: ["partial", "no"], limit: 25) {
            total
            rows {
                id
                conversationId
                createdAt
                action
                text
                judgeVerdict
                judgeReason
                feedback
                slackUserId
                user {
                    id
                    firstName
                    lastName
                    email
                }
                precedingUserText
            }
        }
        negativeFeedback: botAuditMessages(feedback: negative, limit: 25) {
            total
            rows {
                id
                conversationId
                createdAt
                action
                text
                judgeVerdict
                judgeReason
                feedback
                slackUserId
                user {
                    id
                    firstName
                    lastName
                    email
                }
                precedingUserText
            }
        }
    }
`)

export const BotAuditConversation = gql(/* GraphQL */ `
    query BotAuditConversation($id: ID!) {
        botAuditConversation(id: $id) {
            id
            slackChannelId
            threadTs
            slackUserId
            createdAt
            user {
                id
                firstName
                lastName
                email
            }
            messages {
                id
                role
                text
                action
                metadata
                judgeVerdict
                judgeReason
                feedback
                durationMs
                createdAt
            }
            logs {
                id
                logId
                level
                message
                details
                slackUserId
                conversationId
                createdAt
            }
        }
    }
`)

export const BotAuditLogs = gql(/* GraphQL */ `
    query BotAuditLogs(
        $startDate: DateTimeISO
        $endDate: DateTimeISO
        $levels: [BotLogLevel!]
        $search: String
        $page: Int
        $limit: Int
    ) {
        botAuditLogs(
            startDate: $startDate
            endDate: $endDate
            levels: $levels
            search: $search
            page: $page
            limit: $limit
        ) {
            total
            rows {
                id
                logId
                level
                message
                details
                slackUserId
                conversationId
                createdAt
                user {
                    id
                    firstName
                    lastName
                    email
                }
            }
        }
    }
`)

export const BotAuditMessages = gql(/* GraphQL */ `
    query BotAuditMessages(
        $startDate: DateTimeISO
        $endDate: DateTimeISO
        $verdicts: [String!]
        $feedback: BotAuditFeedbackFilter
        $action: String
        $search: String
        $page: Int
        $limit: Int
    ) {
        botAuditMessages(
            startDate: $startDate
            endDate: $endDate
            verdicts: $verdicts
            feedback: $feedback
            action: $action
            search: $search
            page: $page
            limit: $limit
        ) {
            total
            rows {
                id
                conversationId
                createdAt
                action
                text
                judgeVerdict
                feedback
                durationMs
                slackUserId
                user {
                    id
                    firstName
                    lastName
                    email
                }
                precedingUserText
            }
        }
    }
`)
